import { HTTP } from "@/utils/http-common"

export default {
  list() {
    return new Promise((resolve, reject) => {
      HTTP.get("/business/api-keys")
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  create(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post("/business/api-keys", payload)
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  revoke(id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/api-keys/${id}/revoke`)
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  remove(id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/business/api-keys/${id}`)
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },
}
